import React from 'react';
import './Partners.css';

import atlanticLogo from '../assets/partenaire/altantic.jpg';
import daikinLogo from '../assets/partenaire/daikin-seeklogo.png';
import fujitsuLogo from '../assets/partenaire/fujitsu-seeklogo.png';
import mitsubishiElectricLogo from '../assets/partenaire/mitsubishi-electric-seeklogo.png';
import panasonicLogo from '../assets/partenaire/panasonic-seeklogo.png';
import samsungLogo from '../assets/partenaire/samsung-seeklogo.png';

import qualipacLogo from '../assets/logo-qualipac-RGE.PNG';
import capebLogo from '../assets/capeb.jpg';

const PARTNERS = [
  {
    name: 'Daikin',
    logo: daikinLogo,
  },
  {
    name: 'Mitsubishi Electric',
    logo: mitsubishiElectricLogo,
  },
  {
    name: 'Atlantic',
    logo: atlanticLogo,
  },
  {
    name: 'Fujitsu',
    logo: fujitsuLogo,
  },
  {
    name: 'Samsung',
    logo: samsungLogo,
  },
  {
    name: 'Panasonic',
    logo: panasonicLogo,
  },
];

const CERTIFS = [
  {
    title: 'RGE QualiPAC',
    subtitle:
      "Reconnu Garant de l'Environnement — certification officielle de l'État",
    accent: '#7c3aed',
    logo: qualipacLogo,
    alt: 'Certification RGE QualiPAC',
  },
  {
    title: 'CAPEB',
    subtitle: "L'Artisanat du Bâtiment — Grande Couronne Île-de-France",
    accent: '#c8102e',
    logo: capebLogo,
    alt: 'Membre CAPEB',
  },
];

export default function Partners() {
  return (
    <section id="certif" className="partners">
      <div className="container">
        <div className="partners__header">
          <div className="partners__label-wrap">
            <span className="about__label">PARTENAIRES & CERTIFICATIONS</span>
            <h2 className="partners__title">
              Des marques de confiance,
              <br />
              <span className="partners__title-accent">un travail certifié</span>
            </h2>
          </div>

          <p className="partners__intro">
            Nous travaillons exclusivement avec des équipements des plus grandes
            marques mondiales et bénéficions des certifications officielles vous
            donnant accès aux aides de l&apos;État.
          </p>
        </div>

        <div className="partners__logos-grid">
          {PARTNERS.map((partner, index) => (
            <div className="partners__logo-card" key={index}>
              <div className="partners__logo-inner">
                <img
                  src={partner.logo}
                  alt={`Logo ${partner.name}`}
                  className="partners__logo-img"
                  loading="lazy"
                />
              </div>
              <span className="partners__logo-name">{partner.name}</span>
            </div>
          ))}
        </div>

        <div className="partners__sep">
          <span />
          <span className="partners__sep-label">Certifications officielles</span>
          <span />
        </div>

        <div className="partners__certifs">
          {CERTIFS.map((certif, index) => (
            <div
              className="partners__certif"
              key={index}
              style={{ '--accent': certif.accent }}
            >
              <div className="partners__certif-logo-wrap">
                <img
                  src={certif.logo}
                  alt={certif.alt}
                  className="partners__certif-logo"
                  loading="lazy"
                />
              </div>

              <div className="partners__certif-body">
                <strong className="partners__certif-title">{certif.title}</strong>
                <p className="partners__certif-sub">{certif.subtitle}</p>
              </div>

              <div
                className="partners__certif-badge"
                style={{ background: certif.accent }}
              >
                Certifié
              </div>
            </div>
          ))}
        </div>

        <div className="partners__note">
          <svg
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4M12 8h.01" />
          </svg>
          <p>
            Nos certifications RGE vous permettent de bénéficier des aides
            financières de l&apos;État : <strong>MaPrimeRénov&apos;</strong>,{' '}
            <strong>CEE</strong>, <strong>éco-PTZ</strong> et TVA réduite à 5,5 %.
          </p>
        </div>
      </div>
    </section>
  );
}